import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

function SEOPageTitle({ title }) {
  return (
    <Helmet>
      <title>{title} | Otrix Wellness Club</title>
    </Helmet>
  );
}

SEOPageTitle.propTypes = {
  title: PropTypes.string.isRequired
};

export default SEOPageTitle;
